import script from "./member-version.vue?vue&type=script&setup=true&lang=js"
export * from "./member-version.vue?vue&type=script&setup=true&lang=js"

import "./member-version.vue?vue&type=style&index=0&id=7ff32f59&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ff32f59"]])

export default __exports__